import React from 'react';
import { Reveal, SectionHeading } from '../SectionHeading';
import { WHY_CHOOSE } from '../../data/siteData';

export const WhyChoose = () => (
  <section id="why-us" data-testid="why-choose-section" className="py-20 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        label="Why Choose WorkLynx"
        title="Built for Businesses That Need to Execute, Not Experiment"
        subtitle="Eight reasons enterprises and startups trust WorkLynx as their workforce and operations partner."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WHY_CHOOSE.map((w, i) => (
          <Reveal key={w.title} delay={i * 0.06}
            data-testid={`why-card-${i}`}
            className="group p-7 border border-slate-200 rounded-lg bg-white hover:border-[#0066CC]/40 hover:shadow-[0_12px_36px_rgba(10,25,47,0.10)] hover:-translate-y-1 transition-all duration-300">
            <div className="w-12 h-12 rounded-md bg-slate-100 group-hover:bg-[#0A192F] flex items-center justify-center mb-5 transition-colors duration-300">
              <w.icon className="w-5 h-5 text-[#0A192F] group-hover:text-[#4DA3FF] transition-colors duration-300" />
            </div>
            <h3 className="font-semibold text-[#0A192F] font-heading">{w.title}</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{w.desc}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
